import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CategoryChildRequest, CategoryParentRequest, CategoryProfitRequest, CategoryResponse } from '../models/category.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private url = environment.api + "api/erp/inventory/category";

  constructor(private http: HttpClient) { }

  getCategories() {
    return this.http.get(this.url);
  }

  postCategory(newCategory: any) {
    return this.http.post(this.url, newCategory);
  }

  deleteCategory(idCategory: number) {
    return this.http.delete(this.url + "/" + idCategory);
  }

  updateCategory(idCategory: number, updatedCategory: CategoryResponse) {
    return this.http.put(this.url + "/" + idCategory, updatedCategory);
  }

  //priceList:idPriceList
  addProfitToCategory(categoryProfits:CategoryProfitRequest[]){
    return this.http.post(this.url + "/profit", categoryProfits);
  }

  getCategoriesProfit(){
    return this.http.get(this.url + "/profit");
  }

  getCategoriesProfitGrouped(type: any){
    return this.http.get(this.url + `/profit-grouped?type=${type}`);
  }
}
